"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGES = exports.LOCALES_FOR_ADMIN = exports.LOCALES = void 0;
exports.LOCALES = ['en', 'de', 'fr'];
exports.LOCALES_FOR_ADMIN = ['en_US', 'de_DE', 'de_DE_EURO', 'fr-FR'];
exports.LANGUAGES = ['de', 'en_US', 'fr'];
//# sourceMappingURL=enums.js.map